import { useQuery } from '@apollo/client'
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useUpdatePermissions from '@/hooks/permissions/useUpdatePermissions'
import { getSafeReturnPath, useDefaultAuthRedirect } from '@/pages/SignIn/utils'

import { IS_LOGGED_IN } from './queries'

interface AuthRouteProps {
  children: ReactNode
}

export interface SignInQueryResult {
  isLoggedIn: boolean
}

const AuthRoute = ({ children }: AuthRouteProps) => {
  const location = useLocation()
  const { data } = useQuery<SignInQueryResult>(IS_LOGGED_IN)
  useUpdatePermissions({ isLoggedIn: Boolean(data?.isLoggedIn) })
  const defaultAuthRedirect = useDefaultAuthRedirect()

  if (data?.isLoggedIn && location.pathname === '/signIn') {
    // Honor the deep link the user was originally headed to (ENG-1714).
    // SignIn also navigates on submit; redirecting here to the same validated
    // return path keeps the two consistent so the guard can't clobber it back
    // to the default dashboard.
    const returnPath = getSafeReturnPath(location.state?.from)
    return <Navigate to={returnPath ?? defaultAuthRedirect} replace />
  }

  if (!data?.isLoggedIn && !(location.pathname === '/signIn')) {
    return <Navigate state={{ from: location }} to="/signIn" />
  }

  return children
}

export default AuthRoute
